import { render } from "./CardioRelatedQuestions.vue?vue&type=template&id=3d56742c&scoped=true"
import script from "./CardioRelatedQuestions.vue?vue&type=script&lang=js"
export * from "./CardioRelatedQuestions.vue?vue&type=script&lang=js"

import "./CardioRelatedQuestions.vue?vue&type=style&index=0&id=3d56742c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d56742c"]])

export default __exports__